
let stepNumber = 1;
window.subscriptionFlow = {
  decor:'',
  decor_style:'',
  variant_id:null,
  selling_plan_id:null,
  redirect_url:'',
  plan:''
}
class subscriptionFunnel {
  constructor(){
  // manage steps
  document.querySelectorAll("[data-active-tab]").forEach(ele=>{
    ele.addEventListener("click",(event)=>{
      this._manageTab(event);
    })
  })

  //next tab content
  document.querySelectorAll("[data-btn-tab]").forEach(ele=>{
    ele.addEventListener("click",(event)=>{
      this._nextStep(event);
    })
  });

  document.querySelectorAll('input[name="subscription-step1"]').forEach(ele=>{
    ele.addEventListener("click",(event)=>{
      let $this = event.currentTarget;
      window.subscriptionFlow.decor = $this.value;
      if($this.value == 'yes'){
        document.querySelector('[data-active-tab="4"]').classList.remove('d-none');
        document.querySelector('[data-active-tab="5"]').classList.add('d-none');
        let parent = document.querySelector('[data-active-tab="4"]');
        parent.querySelector('[step_text]').innerText = 'sign type';
        // document.querySelectorAll(".only_decor").forEach((el) => {
        //   el.classList.remove('d-none');
        // });
      }else{
        document.querySelector('[data-active-tab="4"]').classList.add('d-none');
        document.querySelector('[data-active-tab="5"]').classList.remove('d-none');
        let parent = document.querySelector('[data-active-tab="5"]');
        parent.querySelector('[step_number_mob]').innerText = '4';
        parent.querySelector('[step_number]').innerText = '4';
        // document.querySelectorAll(".only_decor").forEach((el) => {
        //   el.classList.add('d-none');
        // });
      }
      this._currentTab(2);
    })
  });

  document.querySelectorAll("[style_select]").forEach(ele=>{
    ele.addEventListener("click",(event)=>{
      let $this = event.currentTarget;
      window.subscriptionFlow.decor_style = $this.getAttribute('decor_style');
      if(window.globalVariables.template == 'product'){
        let selected = $this.closest('.subscription-plans')
        selected.querySelector('[selected_style]').innerText = window.subscriptionFlow.decor_style
        if(document.querySelector('[error_message]').innerHTML !=''){
          document.querySelector('[error_message]').innerHTML = '';
        }
      }else{
        this._currentTab(3);
      }
    })
  })

  document.querySelectorAll('[choos_plan]').forEach(ele=>{
    ele.addEventListener('click',(event)=>{ 
      let $this = event.currentTarget;
      
      let parent = $this.closest('[plan_parent]');
      let mainProductData = JSON.parse(parent.querySelector("[data-main-product]").innerText);
      if(window.subscriptionFlow.decor_style == '' || window.subscriptionFlow.decor_style == undefined){
        document.querySelector('[error_message]').innerText = 'Please select the style';
        event.preventDefault();
        return;
      }else{
        document.querySelector('[error_message]').innerText = '';
      }
      mainProductData = mainProductData.find(x=> x.variant_title ==window.subscriptionFlow.decor_style);
      window.subscriptionFlow.variant_id = mainProductData.variant_id;
      window.subscriptionFlow.selling_plan_id = mainProductData.selling_plan_id
      if(window.globalVariables.template == 'product'){
        let selected = $this.closest('.subscription-plans');
        window.subscriptionFlow.plan = $this.getAttribute('plan');
        selected.querySelector('[selected_plan]').innerText = window.subscriptionFlow.plan;
      }else{
        if(window.subscriptionFlow.decor == 'no'){
          $this.setAttribute('disabled', true);
          $this.classList.add('loading');
          this._clear_cart(event);
        }else if(window.subscriptionFlow.decor == 'yes'){
          this._currentTab(4);
        }
      }
      
    })
  })

  document.querySelectorAll('[sign_select]').forEach(ele=>{
    ele.addEventListener('click',(event)=>{
      let $this = event.currentTarget;
      window.subscriptionFlow.redirect_url = $this.getAttribute('data-href');
      if(window.subscriptionFlow.decor == 'no'){
      }else{
        this._clear_cart(event);
      }
    })
  })
  }
  _manageTab(event){
    let currentEle = event.currentTarget;
    stepNumber =  parseInt(currentEle.getAttribute('data-active-tab'));
    this._currentTab(stepNumber);
  }
  _nextStep(event){
    let currentEle = event.currentTarget;
    stepNumber =  parseInt(currentEle.getAttribute('data-btn-tab'));
    this._currentTab(stepNumber)
  }

  _currentTab(stepNumber){
    document.querySelectorAll("[data-active-tab]").forEach(ele=>{
      let currentStep = parseInt(ele.getAttribute('data-active-tab'));
      if (currentStep < stepNumber) {
        ele.classList.remove("active");
        ele.classList.remove("disabled");
      }
      else if( currentStep == stepNumber){
        ele.classList.add("active");
        ele.classList.remove("disabled");
      }else{
        ele.classList.remove("active");
        ele.classList.add("disabled");
      }
    });

    document.querySelectorAll("[data-tab-content]").forEach(ele=>{
      let currentContentTab = parseInt(ele.getAttribute("data-tab-content"));
      if (currentContentTab == stepNumber) {
        ele.classList.remove("d-none");
      }else{
        ele.classList.add("d-none");
      }
    }); 
  }
  async _clear_cart(event){
    const response_clear = await fetch(`/cart/clear.js`, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json'
      }
    })
     if(response_clear.ok){
      this._AddToCart(event);
     }
   }
  _AddToCart(event){
    let $this = event.target;
    var items = [];
    if($this.classList.contains('gift_popup_btn')){
      let var_id = $this.closest('.wrapped-gift-data').getAttribute('current_variant_id')
      items.push({
        quantity: 1,
        id: parseInt(var_id)
      });
    }else{
      items.push({
        quantity: 1,
        id: parseInt(window.subscriptionFlow.variant_id),
        selling_plan : window.subscriptionFlow.selling_plan_id
      });
    }
    
  
    const body = JSON.stringify({
    items: items
    });
  
    fetch(`${routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: body
    })
    .then((response) => {
      return response.text();
    })
    .then((_state) => {

      let dataJSON = ((typeof res == 'object') ? _state : JSON.parse(_state));
      if(dataJSON.errors){
        window.notificationEle.updateNotification('Not added', dataJSON.errors, {
          type: 'error',
          timeout: 5000
        });
      }
      if(window.subscriptionFlow.decor == 'yes'){
        window.location.href = window.subscriptionFlow.redirect_url;
      }else if(window.subscriptionFlow.decor == 'no'){
         let cartElement = document.querySelector('cart-form');
         cartElement.getCartData();
        const getcart = setInterval(function(){ 
          let item = window.globalVariables.cart.items[0];
          let price = Utility.formatMoney(window.globalVariables.cart.total_price, window.globalVariables.money_format);
          let parent = document.querySelector('[last_step]');
          parent.querySelector('[plan_img]').setAttribute('src',item.featured_image.url+'&width=350');
          parent.querySelector('[pr_title]').innerHTML = item.product_title;
          parent.querySelector('[selected_style]').innerHTML = item.variant_title;
          parent.querySelector('[selected_plan]').innerHTML = item.selling_plan_allocation.selling_plan.name;
          parent.querySelector('[sub_total]').innerHTML = price;
          parent.querySelector('[cart_total]').innerHTML = price;
          clearInterval(getcart);   
          
        }, 500);
         this._currentTab(5);
      }else{
        ProductForm.prototype.addToCart();
      }
      
    }).catch(e => {
      console.log(e)
      //document.querySelector('#cart-icon-desktop').click();
    })
    .finally(() => {
      if($this.classList.contains('add-text')){
        let prnt = $this.closest('.loading');
        
        prnt.removeAttribute('disabled');
        prnt.classList.remove('loading');
      }
      $this.classList.remove('loading');
      $this.removeAttribute('disabled');
    });
  }
}
//new subscriptionFunnel()
typeof subscriptionFunnel !== 'undefined' && new subscriptionFunnel();


const selectors_stick = {
  cartCheckout: document.querySelector('#subscription-checkoutbtn'),
  checkoutSticky: document.querySelector('.checkoutbtn-sticky')
};

class templateCartJS {
  constructor() {
      this.stickyCheckout();
  }

  // Sticky checkout container on oage scroll
  stickyCheckout(){
      const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
              if(entry.isIntersecting){
                selectors_stick.checkoutSticky.classList.remove('active');
              } else {
                selectors_stick.checkoutSticky.classList.add('active');
              }
          })
      });
      observer.observe(selectors_stick.cartCheckout);
  }
}

typeof templateCartJS !== 'undefined' && new templateCartJS();